import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Flame, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back!");
      nav(user.role === "admin" ? "/travisb-admin" : "/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tb-glow min-h-screen flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <span className="w-10 h-10 rounded-xl flex items-center justify-center tb-btn-primary"><span className="font-head font-extrabold text-white text-lg">T</span></span>
          <span className="font-head font-extrabold text-xl text-white">Travis<span className="tb-gradient-text">B</span></span>
        </Link>
        <div className="tb-card p-7 sm:p-8">
          <h1 className="font-head text-2xl font-bold text-white mb-1">Welcome back</h1>
          <p className="text-sm text-gray-400 mb-6">Log in to trade crypto & gift cards.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-wider text-gray-400">Email</label>
              <input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 w-full px-4 py-3 rounded-xl bg-[#0A1026] border border-blue-500/25 text-white outline-none focus:border-blue-400 transition-colors" placeholder="you@example.com" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-gray-400">Password</label>
              <input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 w-full px-4 py-3 rounded-xl bg-[#0A1026] border border-blue-500/25 text-white outline-none focus:border-blue-400 transition-colors" placeholder="••••••••" />
            </div>
            <button data-testid="login-submit-button" disabled={loading} className="w-full flex items-center justify-center gap-2 py-3.5 rounded-xl font-semibold tb-btn-primary disabled:opacity-60">
              {loading && <Loader2 size={18} className="animate-spin" />} Log In
            </button>
          </form>
          <p className="mt-6 text-center text-sm text-gray-400">
            No account? <Link to="/signup" data-testid="login-to-signup-link" className="text-blue-300 font-semibold hover:text-blue-200">Create one</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
